import { Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import OpenButton from "../../../ui/components/OpenButton/OpenButton";

import useHasRight from "../../../authorization/hooks/useHasRight";

import DistributionArgsForm from "../../components/DistributionArgsForm/DistributionArgsForm";
import DistributionArgsTable from "../../components/DistributionArgsTable/DistributionArgsTable";
import DistributionPresetForm from "../../components/DistributionPresetForm/DistributionPresetForm";
import DistributionPresetsTable from "../../components/DistributionPresetsTable/DistributionPresetsTable";
import DistributionSettingsOther from "../../components/DistributionSettings/DistributionSettingsOther";

export default function DistributionSettingsView({ publisher }) {
	const { t } = useTranslation();
	const hasRight = useHasRight();

	return (
		<>
			<Header as="h3">{t("presets", "Presets")}</Header>

			<DistributionPresetsTable publisher={publisher} />

			{hasRight("distributions.addPresets") && (
				<OpenButton text={t("addPreset", "Add preset")}>
					{({ setOpen }) => <DistributionPresetForm publisher={publisher} onClose={() => setOpen(false)} />}
				</OpenButton>
			)}

			{hasRight("distributions.addPresets") && (
				<>
					<Header as="h3">{t("overriddenDistributionArgs", "Overridden distribution args")}</Header>

					<DistributionArgsTable publisher={publisher} />

					<OpenButton text={t("addArgs", "Add args")}>
						{({ setOpen }) => <DistributionArgsForm publisher={publisher} onClose={() => setOpen(false)} />}
					</OpenButton>
				</>
			)}
			{hasRight("distributions.addPresets") && (
				<>
					<Header as="h3">{t("other", "Other")}</Header>
					<DistributionSettingsOther organization={publisher} />
				</>
			)}
		</>
	);
}
